import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUserJob } from "@/types";

interface UserJobState {
    userJobs: IUserJob[];
    activeUserJob: IUserJob | null;
}

const initialState: UserJobState = {
    userJobs: [],
    activeUserJob: null,
};

const userJobSlice = createSlice({
    name: "userJob",
    initialState,
    reducers: {
        setUserJobs: (state, { payload }: PayloadAction<IUserJob[]>) => {
            return {
                ...state,
                userJobs: payload,
            };
        },
        setActiveUserJob: (state, { payload }: PayloadAction<IUserJob>) => {
            return {
                ...state,
                activeUserJob: payload,
            };
        },
        clearActiveUserJob: state => {
            return {
                ...state,
                activeUserJob: null,
            };
        },
        updateUserJob: (state, { payload }: PayloadAction<IUserJob>) => {
            const isInJobList = state.userJobs.some(
                userJob => userJob.id === payload.id,
            );
            if (isInJobList) {
                return {
                    ...state,
                    userJobs: state.userJobs.map(userJob =>
                        userJob.id === payload.id ? payload : userJob,
                    ),
                };
            } else {
                // Add new job
                return {
                    ...state,
                    userJobs: [...state.userJobs, payload],
                };
            }
        },
        deleteUserJob: (state, { payload }: PayloadAction<string>) => {
            return {
                ...state,
                userJobs: state.userJobs.filter(
                    userJob => userJob.id !== payload,
                ),
            };
        },
        addUserJob: (state, { payload }: PayloadAction<IUserJob>) => {
            return {
                ...state,
                userJobs: [...state.userJobs, payload],
            };
        },
    },
});

export const {
    setUserJobs,
    setActiveUserJob,
    clearActiveUserJob,
    updateUserJob,
    deleteUserJob,
    addUserJob,
} = userJobSlice.actions;
export const { reducer: userJobReducer } = userJobSlice;
